import {FC, useEffect, useState} from 'react';
import clsx from 'clsx';

import Icon, {Icons} from '../../Icon';
import CardBordered from '../CardBordered';
import s from './styles.module.scss';

export enum AlertTypes {
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info',
}

const IconsMap = {
  [AlertTypes.error]: Icons.infoCircle,
  [AlertTypes.info]: Icons.infoCircle,
  [AlertTypes.success]: Icons.infoCircle,
  [AlertTypes.warning]: Icons.infoCircle,
};

interface AlertProps {
  type: AlertTypes;
  message: any;
  className?: string;
  autoClose?: boolean | number;
}

const Alert: FC<AlertProps> = ({type, message, className, autoClose}) => {
  const [isVisible, setVisible] = useState(true);
  const IconName = IconsMap[type];

  useEffect(() => {
    if (!autoClose) return;

    const timeout = setTimeout(
      () => setVisible(false),
      typeof autoClose === 'boolean' ? 5000 : autoClose
    );

    return () => {
      clearTimeout(timeout);
    };
  }, [autoClose]);

  if (!isVisible) return null;

  return (
    <CardBordered className={clsx(s.alert, s[`alert--${type}`], className)}>
      <Icon name={IconName} className={clsx(s.alert__icon, s[`alert__icon--${type}`])} />
      <div className={s.alert__content}>{message}</div>
    </CardBordered>
  );
};

export default Alert;
